export const REF_NAME = 'ORIGIN';
export const REF_PATH = 'origin';
export const NAME = 'Origin/Destination';
